export default ({ defaultLocale, isValidPath, ingredients, findIngredientID }) => ({
  getCategoryTitle: category => category.title[defaultLocale],
  getItemTitle: item => item.title[defaultLocale],
  getItemDescription: item => {
    const ingredientID = findIngredientID(item)
    return ingredientID ?
      (ingredients.find(i => i.id === ingredientID) || { name: '' }).name : (item.name || {})[defaultLocale] || ''
  },
  getId: item => item.stepID || item.stepNewKey,
  isValidPath: path => isValidPath(path),
})
